// src/Footer.js
import React, { useEffect, useState } from 'react';
import '../css/Footer.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch("https://adinathbuilder.com/admin/api/app/settings")
      .then(res => res.json())
      .then(data => {
        if (data?.status && data.data) {
          setSettings(data.data);
        } else {
          console.error("Invalid settings data:", data);
        }
      })
      .catch(err => console.error("Error fetching settings:", err));
  }, []);

  const logoUrl = settings?.logo
    ? `https://adinathbuilder.com/admin/public/${settings.logo}`
    : '';

  const primaryMobile = settings?.mobile || '8191000879';

  return (
    <footer className="footer py-5">
      <div className="footer-section contact-us">
        {logoUrl && <img src={logoUrl} alt="Logo" className="footer-logo" />}
        <h5><b><i>Now Build With Us</i></b></h5>
        <p className="text-footer-p">
          {settings?.about_company}
        </p>
      </div>

      <div className="footer-section quick-links">
        <h3>Quick Links</h3>
        <ul>
          <li><a href="/">Home</a></li>
          <li><a href="/about-us">About</a></li>
          <li><a href="/image-gallery">Gallery</a></li>
          <li><a href="/visit">Visits</a></li>
          <li><a href="/contact-us">Contact Us</a></li>
          <li><a href="/">Terms & Conditions</a></li>
        </ul>
      </div>

      <div className="footer-section opening-hours">
        <div className="footer-sectionp quick-links">
          <h3>OUR PROJECTS</h3>
          <ul>
            <li><a href="/running-projects">RUNNING PROJECTS</a></li>
            <li><a href="/upcoming-projects">UP-COMING PROJECTS</a></li>
            <li><a href="/completed-projects">COMPLETED PROJECTS</a></li>
          </ul>
        </div>

        <div className="social-icons">
  {settings?.fb && (
    <a href={settings.fb} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-facebook-f"></i>
    </a>
  )}
  {settings?.instagram && (
    <a href={settings.instagram} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-instagram ms-2"></i>
    </a>
  )}
  {settings?.twitter && (
    <a href={settings.twitter} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-twitter"></i>
    </a>
  )}
  {settings?.linkedin && (
    <a href={settings.linkedin} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-linkedin-in"></i>
    </a>
  )}
  {settings?.youtube && (
    <a href={settings.youtube} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-youtube ms-2"></i>
    </a>
  )}
</div>

      </div>

      <div className="footer-section opening-hours">
        <h3>Find Us On</h3>
        <a rel="nofollow" className="component-target" href={`tel:+91${primaryMobile}`}>
          <i className="fa fa-phone"></i>
          <span className="component-target-text"> +91 {primaryMobile}</span>
        </a><br />
        <a rel="nofollow" className="component-target" href="tel:+91 9412262935">
          <i className="fa fa-phone"></i>
          <span className="component-target-text"> +91 9412262935</span>
        </a><br />
        <a href="mailto:adinathinfratech@gmail.com">
          <br /><i className="fas fa-envelope"></i> {settings?.email}
        </a>
        <div className="footer-section location text-start ms-0"><br />
          <h3>Location</h3>
          <p>Visit us at our location:</p>
          <span>
            <a href="/" aria-label="Location" target="_blank" rel="noopener noreferrer">
              <p><span><i className="fas fa-map-marker-alt"></i> Head Office: 508, 5th Floor, Maruti Plaza, Sanjay Place, Agra (U.P.) </span></p>
            </a>
          </span>
        </div>
      </div>

      <div className="copyright">
        <p className='text-whitesmoke'>
          ©ADINATH GROUP OF COMPANY 2025 | All rights reserved. Design and Developed by
          <span> <a href="https://www.magnumdigitalsolution.com/" target="_blank" rel="noreferrer">Magnum Digital Solutions</a></span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
